<template>
  <div class="mall-card">
    <slot />
  </div>
</template>

<script>
// 테두리 카드 (배송지 / 주문상품 / 결제 카드)
export default {
  name: 'MallCard',
}
</script>

<style scoped>
.mall-card {
  display: flex;
  padding: 19px 15px;
  flex-direction: column;
  gap: 16px;
  border: 1px solid #E5E8EB;
  border-radius: 12px;
  background: #FFF;
}
</style>



// WEBPACK FOOTER //
// src/components/new/atoms/MallCard.vue